import { ReactNode } from 'react'

interface LandingLayoutProps {
    children: ReactNode
}

export function LandingLayout({ children }: LandingLayoutProps) {
    return <>{children}</>
}
